import React, {ReactNode} from 'react';
import {
    Card,
    Empty,
    Flex,
    Space,
    Tag, Typography,
} from 'antd';

import {
    HistoryOutlined, LinkOutlined,
} from '@ant-design/icons';
import {InvocationChangeLog} from "../../../../../../../models/logger/logger.data";

const { Text } = Typography;

interface EntityLinkOptions {
    entityName?: string;
    entityId?: string;
}

interface InvocationChangeLogsTabProps {
    changeLogs: InvocationChangeLog[];
}

const renderEntityLogLink = ({
                                 entityName,
                                 entityId,
                             }: EntityLinkOptions): ReactNode => {
    if (!entityName || !entityId) {
        return null;
    }

    return (
        <a
            href={'#'}
            className="invocation-entity-link"
            onClick={(event) => {
                event.preventDefault();
            }}
        >
            <LinkOutlined />
            <span>{entityName}</span>
            <Text type="secondary" className="invocation-entity-id">
                #{entityId}
            </Text>
        </a>
    );
};

export function InvocationChangeLogsTab({
                                            changeLogs,
                                        }: InvocationChangeLogsTabProps) {
    if (!changeLogs.length) {
        return <Empty description="No change logs" />;
    }

    return (
        <div className="invocation-change-list">
            {changeLogs.map((changeLog, index) => {

                return (
                    <Card
                        key={`${changeLog.date}-${changeLog.entityName}-${changeLog.entityId}-${index}`}
                        className="invocation-change-card"
                        bordered={false}
                    >
                        <div className="invocation-change-card__top">
                            <Space size={8} wrap>
                                <HistoryOutlined />
                                <Text type="secondary">{changeLog.date}</Text>

                                {renderEntityLogLink({
                                    entityName: changeLog.entityName,
                                    entityId: changeLog.entityId,
                                })}

                                {changeLog.parentEntityName ? renderEntityLogLink({
                                    entityName: changeLog.parentEntityName,
                                    entityId: changeLog.parentEntityId,
                                }) : null}
                            </Space>

                            <Tag color="purple">
                                Changes: {changeLog.changesCount || '—'}
                            </Tag>

                            <Tag color="green">
                                {changeLog.operation}
                            </Tag>
                        </div>

                        <div className="invocation-change-card__fields">
                            <Text type="secondary">Changed fields:</Text>

                            {changeLog.changes.length ? (
                                <Flex gap={6} wrap="wrap">
                                    {changeLog.changes.map((change) => (
                                        <Tag key={change.field} className="invocation-field-tag">
                                            {change.field}: {change.old ? (change.old + ' → ' ) : ''} {change.new}
                                        </Tag>
                                    ))}
                                </Flex>
                            ) : (
                                <Text>—</Text>
                            )}
                        </div>
                    </Card>
                );
            })}
        </div>
    );
}